/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Purchase_Order_InvalidInputs */

const en_error_purchase_order_invalid = /** @type {(inputs: Error_Purchase_Order_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The purchase order cannot be saved like this.`)
};

/**
* | output |
* | --- |
* | "The purchase order cannot be saved like this." |
*
* @param {Error_Purchase_Order_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_purchase_order_invalid = /** @type {((inputs?: Error_Purchase_Order_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Purchase_Order_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_purchase_order_invalid(inputs)
});